<a
  class="item-menu"
  [routerLink]="item.routerLink"
  routerLinkActive="active-link"
  [ngClass]="{ 'active': expanded, 'collapsed': !isSidebarOpen }"
  (click)="handleClick()"
  [pTooltip]="!isSidebarOpen ? item.label : ''"
  tooltipPosition="right"
>
  <div class="item-content">
    @if (item.icon) {
      <lucide-icon [name]="item.icon" class="item-icon"></lucide-icon>
    }
    @if (isSidebarOpen) {
      <span class="item-label">{{ item.label }}</span>
    }
    
    @if (item.items && isSidebarOpen) {
      <lucide-icon [name]="expanded ? 'ChevronUp' : 'ChevronDown'" class="item-icon chevron-icon"></lucide-icon>
    }
  </div>
</a>

<!-- Inline submenu para sidebar expandido -->
@if (expanded && item.items && isSidebarOpen) {
  <ul class="sub-menu">
    @for (subItem of item.items; track subItem.id) {
      <li>
        <app-item-menu
          [item]="subItem"
          [isSidebarOpen]="true"
          (itemClick)="itemClick.emit($event)">
        </app-item-menu>
      </li>
    }
  </ul>
}

<!-- Floating submenu para sidebar colapsado -->
<ng-template #submenuTemplate>
  <ul class="sub-menu-floating">
    @for (subItem of item.items; track subItem.id) {
      <li>
        <app-item-menu
          [item]="subItem"
          [isSidebarOpen]="true"
          (itemClick)="itemClick.emit($event)">
        </app-item-menu>
      </li>
    }
  </ul>
</ng-template>
